export * from './WindowProvider';
import './version';
//# sourceMappingURL=index.js.map